import React, { useState, useEffect } from 'react'
import { getFirestore, collection, getDocs } from "@firebase/firestore"
import { app } from '../../firebase.js'
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function ApplicationToAdmTime() {
  const [chartData, setChartData] = useState([])
  const [tableData, setTableData] = useState([])
  const db = getFirestore(app)

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "users"))
      const bucketCounts = {
        "0-7 days": 0,
        "8-14 days": 0,
        "15-30 days": 0,
        "31-60 days": 0,
        "61-90 days": 0,
        "90+ days": 0,
      }
      const tableRows = []

      const filterStart = new Date("2024-06-01")

      snapshot.forEach(doc => {
        const data = doc.data()

        if (data.appDate && data.admissionDate) {
          const appDate = data.appDate.toDate()
          const admissionDate = data.admissionDate.toDate()

          if (appDate < filterStart) return

          const diffMs = admissionDate - appDate
          const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

          // Bucket allocation
          if (diffDays <= 7) bucketCounts["0-7 days"]++
          else if (diffDays <= 14) bucketCounts["8-14 days"]++
          else if (diffDays <= 30) bucketCounts["15-30 days"]++
          else if (diffDays <= 60) bucketCounts["31-60 days"]++
          else if (diffDays <= 90) bucketCounts["61-90 days"]++
          else bucketCounts["90+ days"]++

          // Format duration
          let durationDisplay = `${diffDays} days`
          if (diffDays === 0) {
            const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
            const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))
            durationDisplay = `${diffHours}h ${diffMinutes}m`
          }

          // Add to table
          tableRows.push({
            id: doc.id,
            name: data.fullName || "N/A",
            appDate: appDate.toDateString(),
            admissionDate: admissionDate.toDateString(),
            duration: durationDisplay
          })
        }
      })

      const formattedData = Object.keys(bucketCounts).map(key => ({
        range: key,
        count: bucketCounts[key]
      }))

      tableRows.sort((a, b) => new Date(b.admissionDate) - new Date(a.admissionDate))

      setChartData(formattedData)
      setTableData(tableRows)
    }

    fetchData()
  }, [db])

  return (
    <div className="d-flex">
      <LeftBar />
      <div className="flex-grow-1">
        <Dashnav />
        <div className="clientsComp p-4">
          <h2 className="mb-4">Application to Admission Time (From June 2024)</h2>

          {/* Chart */}
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="range" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#4F46E5" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>

          {/* Table */}
          <h3 className="mt-5 mb-3">Detailed Records</h3>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Application Date</th>
                <th>Admission Date</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map(row => (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td>{row.appDate}</td>
                  <td>{row.admissionDate}</td>
                  <td>{row.duration}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default ApplicationToAdmTime